<template>
  <div>
    <div class="dad-wrap">
      <div class="card">
        <!-- <img src="../../assets/img/placard/front.png" class="main-card card-bg" /> -->
        <img :src="frontUrl" class="main-card card-bg" />
        <img :src="qrUrl" :class="{'qr':true, 'loading':qrLoading }" />
        <i class="fa fa-spinner fa-spin loader fa-5x" v-show="qrLoading"></i>

        <!-- <span class="tnc-name">OPOLI</span> -->

        <span class="issue-date" v-if="!issueActive" @click="showIssueInput">{{ issueDate }}</span>
        <input type="text" class="issue-input" ref="issueInput" v-model="issueDate"
          v-if="issueActive" v-on:keypress.enter="issueUpdate" v-on:blur="issueUpdate">

        <span class="license-plate">{{license}}</span>

        <span class="driver-id" v-if="!driverActive" @click="showDriverInput">{{ driverID }}</span>
        <input type="text" class="driver-input" ref="driverInput" v-model="driverID"
          v-if="driverActive" v-on:keypress.enter="driverUpdate" v-on:blur="driverUpdate">
      </div>

      <br/>
      <div class="page-break"></div>
    </div>
    <div class="dad-wrap">
      <div class="card right">
        <!-- <img src="../../assets/img/placard/back.png" class="card-bg" /> -->
        <img :src="backUrl" class="card-bg" />
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
const request = require('browser-request')

export default {
  name: 'provider-print-placard',
  components: {},
  data () {
    return {
      // frontUrl: 'https://stage-opoli-uploads.s3.us-west-2.amazonaws.com/dc5df0cc-060c-4540-b070-f54e7207aecf.png',
      // backUrl: 'https://stage-opoli-uploads.s3.us-west-2.amazonaws.com/efa120d1-f4cd-4152-a1a8-e2ecfbde8840.png',
      // frontUrl: 'https://staging-backoffice.s3.us-west-2.amazonaws.com/staging/front-old.png', // OPOLI
      // backUrl: 'https://staging-backoffice.s3.us-west-2.amazonaws.com/staging/back.png', // OPOLI
      frontUrl: 'https://prod-opoli-app.s3.us-west-2.amazonaws.com/email/placard-front.png', // PTS RS
      backUrl: 'https://prod-opoli-app.s3.us-west-2.amazonaws.com/email/placard-back.png', // PTS RS
      qrUrl: '',
      qrLoading: false,
      issueDate: moment().format('MM/DD/YYYY'),
      issueActive: false,
      license: '',
      driverID: '',
      driverActive: false
    }
  },
  computed: {
    provId () { return this.$route.params.id }
  },
  methods: {
    generateQR () {
      let self = this
      let date = moment(self.issueDate, 'MM/DD/YYYY').format('YYYYMMDD')
      let code = 'TNC;PrimeTimeRideshare;34171;LSO-009455;' + self.license + ';' + self.driverID + ';' + date

      self.qrLoading = true
      request.get({
        url: CONFIG.mediaHost + '/api/qr?text=' + code,
        json: true
      }, function (err, res, body) {
        self.qrLoading = false
        if (err) {
          console.log(err)
          return
        }
        self.qrUrl = body.image
      })
    },
    showIssueInput () {
      let self = this
      self.issueActive = true
      self.$nextTick(() => { self.$refs.issueInput.focus() })
    },
    issueUpdate () {
      this.issueActive = false
      this.generateQR()
    },
    showDriverInput () {
      let self = this
      self.driverActive = true
      self.$nextTick(() => { self.$refs.driverInput.focus() })
    },
    driverUpdate () {
      this.driverActive = false
      this.generateQR()
    }
  },
  mounted () {
    this.driverID = this.$route.params.id
    if (this.$route.query) {
      this.license = this.$route.query.license
    }
    this.generateQR()

    // document.getElementsByClassName("phone-app").style.display = 'none'
  }
}
</script>

<style lang="scss">
body{ background: #ececec; }
#side-menu{ display: none; }

.dad-wrap{
  height: 100vh;
  position: relative;
}
.card{
  position: relative;
  width: 528px;
  height: 408px;
  border-radius: 0;
  border:none;
  box-shadow: none;
  // transform: translateY(250px); // <---- Remove this to revert to original position
  position: absolute;
  bottom: 10px;
  left: calc(50% - 264px);

  // &.right{ float:right; }
  .card-bg{
    width: 528px;
    height: 409px;
  }
  .qr{
    position: absolute;
    top: 65px;
    left: 61px;
    // bottom: 10px;
    // right: 81px;
    width: 172px;
    height: 172px;
    background: rgba(0, 0, 0, 0.3);
    z-index: 2;

    &.loading{ opacity: .5; }
  }
  .loader{
    position: absolute;
    top: 110px;
    left: 110px;
    z-index: 3;
    color: #2581e0;
  }
  span{
    position: absolute;
    color: #222;
    font-weight: 600;
    display: inline-block;
    line-height: 1;
    z-index: 2;
  }
  .tnc-name{
    top: 105px;
    left: 270px;
    // left: 38px;
    width: 180px;
    font-size: 24px;
    // font-size: 26px;
    // padding: 2px 0;
    text-align: center;
  }
  .issue-date{
    top: 175px;
    // top: 105px;
    left: 270px;
    width: 180px;
    font-size: 26px;
    padding: 2px 0;
    text-align: center;
    border: 1px solid transparent;
    letter-spacing: 2px;
    cursor: pointer;

    &:hover{ border:1px solid #ccc; }
  }
  input{
    z-index: 3;
    position: absolute;
    padding: 0 5px !important;
    font-weight: 600;
    font-size: 26px !important;
  }
  .issue-input{
    top: 160px;
    left: 270px;
    width: 180px;
    text-align: center;
    height: 32px;
    letter-spacing: 2px;
  }
  .license-plate{
    top: 257px;
    left: 266px;
    // top: 167px;
    // left: 230px;
    width: 170px;
    font-size: 22px;
    text-align: left;
  }
  .driver-id{
    top: 285px;
    left: 240px;
    // top: 195px;
    // left: 207px;
    width: 160px;
    font-size: 22px;
    text-align: left;
    border: 1px solid transparent;
    padding: 2px 0;
    word-wrap: break-word;
    line-height: 1;
    cursor: pointer;

    &:hover{ border:1px solid #ccc; }
  }
  .driver-input{
    top: 268px;
    left: 240px;
    width: 160px;
    height: 32px;
    font-size: 22px!important;
    text-align: left;
    line-height: 1;
    padding: 0!important;
    word-wrap: break-word;
  }
}

.page-break{ page-break-after: always; }
</style>



// WEBPACK FOOTER //
// src/components/Provider/PrintPlacard.vue